import { Country, Language } from 'src/api/defs/enums.type'
import { useLanguageValue } from 'src/i18n/useLanguage'
import { getEnvConfVal } from '../conf/getEnvConfVal'

export const languageToLocale: { [index: string]: string } = {
    SK: 'sk',
    EN: 'en',
    CS: 'cs',
    UK: 'uk',
    PL: 'pl',
    HU: 'hu',
    RO: 'ro',
    IT: 'it',
    DE: 'de'
}

export const localeToLanguageName: Record<string, string> = {
    sk: 'Slovak',
    en: 'English',
    cs: 'Czech',
    uk: 'Ukrainian',
    ua: 'Ukrainian',
    pl: 'Polish',
    hu: 'Hungarian',
    ro: 'Romanian',
    it: 'Italian',
    de: 'German'
}

export const getLanguageName = (locale: string): string => {
    const normalizedLocale = locale.toLowerCase()
    return localeToLanguageName[normalizedLocale] || normalizedLocale
}

export const locales = getEnvConfVal('LOCALES')
    ?.split(',')
    ?.map(locale => locale.trim())

// export const locales: string[] = [
//     languageToLocale[Language.SK],
//     languageToLocale[Language.EN],
//     languageToLocale[Language.CS],
//     languageToLocale[Language.UK],
//     languageToLocale[Language.PL]
// ]

export const countryToLocale = {
    SVK: languageToLocale.SK,
    CZE: languageToLocale.CS,
    POL: languageToLocale.PL,
    HUN: languageToLocale.HU,
    ROU: languageToLocale.RO,
    ITA: languageToLocale.IT,
    DEU: languageToLocale.DE
}

export const anotherDomainCountryCode = {
    cs: Country.SVK,
    sk: Country.CZE,
    pl: Country.POL,
    hu: Country.HUN,
    ro: Country.ROU,
    it: Country.ITA,
    de: Country.DEU
}

const mapToLocale = (language: Language): string =>
    languageToLocale[language] || languageToLocale.EN

export const useLocale = (): string => mapToLocale(useLanguageValue())

export const mapCountryToLocale = (country: Country): string | undefined =>
    countryToLocale[country] || undefined

export const getAnotherDomainCountryCode = (lang: string): string | undefined =>
    anotherDomainCountryCode[
        lang.toLowerCase() as keyof typeof anotherDomainCountryCode
    ] || undefined

export const mapLocaleToCountry = (locale: string): Country | undefined =>
    Object.keys(countryToLocale).find(
        key => countryToLocale[key as Country] === locale
    ) as Country | undefined

export const languageOptions = (formatLocale: Language): Language[] => {
    const anotherVersionLanguage = mapCountryToLocale(
        getAnotherDomainCountryCode(formatLocale)?.toUpperCase() as Country
    )?.toUpperCase() as Language

    return [
        Language.SK,
        Language.CS,
        Language.EN,
        Language.UK,
        Language.PL,
        Language.HU,
        Language.RO,
        Language.IT,
        Language.DE
    ].sort((a, b) => {
        if (a === formatLocale) {
            return -1
        }
        if (b === formatLocale) {
            return 1
        }
        if (a === anotherVersionLanguage) {
            return -1
        }
        if (b === anotherVersionLanguage) {
            return 1
        }
        return 0
    })
}
